/**
 * Dashboard cohort/group widget.
 */
import React from "react";
import { Box, Divider } from "@mui/material";
import { Icon } from "@iconify/react";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";

import { VText } from "form";
import { useAsterController } from "context";
import { BThumb } from "components";

/**
 * Shows the learner's groups.
 */
const DashboardGroup = () => {
  const { t } = useTranslation("common");

  const [controller] = useAsterController();
  const { groups, loadedDashboard } = controller;

  return (
    <>
      <Box className="w-full flex justify-center lg:justify-start pt-8">
        <VText className="text-2xl">{t("My Group")}</VText>
      </Box>
      <Box className="w-full rounded-md border border-solid border-gray-200 dark:border-gray-500 px-8 py-6 my-5">
        {loadedDashboard ? (
          groups.map((item, index) => (
            <Box key={index}>
              <Box className="">
                <Box className="flex items-center gap-4">
                  <BThumb src={item.cover_url} error="" className="w-16 h-14 aspect-[5/4] rounded-md flex-shrink-0" />
                  <VText>{item.name}</VText>
                </Box>

                <Box className="flex gap-2 mt-2">
                  <VText color="secondary" className="flex items-center">
                    <Icon icon="lucide:eye" />
                    &nbsp;{t("Public")}
                  </VText>
                  <VText color="secondary" className="flex items-center ml-4">
                    <Icon icon="akar-icons:people-group" />
                    &nbsp;{item.users?.length}&nbsp;{t("Members")}
                  </VText>
                </Box>
              </Box>
              {index !== groups.length - 1 && <Divider className="bg-gray-200 dark:bg-gray-500 my-4" />}
            </Box>
          ))
        ) : (
          <Skeleton className="w-full h-16" />
        )}
      </Box>
    </>
  );
};

export default DashboardGroup;
